const Config = {
    BASE_URL: "https://8na10gv9vf.execute-api.ap-south-1.amazonaws.com/prod",
}

export default Config; 